var th = {
	"neptune.Button.loadingAriaLabel": "กำลังโหลด",
	"neptune.Chips.ariaLabel": "ล้าง {choice}",
	"neptune.ClearButton.ariaLabel": "ล้าง",
	"neptune.CloseButton.ariaLabel": "ปิด",
	"neptune.DateInput.day.label": "วัน",
	"neptune.DateInput.day.placeholder": "วัน",
	"neptune.DateInput.month.label": "เดือน",
	"neptune.DateInput.year.label": "ปี",
	"neptune.DateInput.year.placeholder": "ปี",
	"neptune.DateLookup.day": "วัน",
	"neptune.DateLookup.goTo20YearView": "ไปที่มุมมอง 20 ปี",
	"neptune.DateLookup.month": "เดือน",
	"neptune.DateLookup.next": "ถัดไป",
	"neptune.DateLookup.previous": "ก่อนหน้า",
	"neptune.DateLookup.selected": "เลือกแล้ว",
	"neptune.DateLookup.twentyYears": "20 ปี",
	"neptune.DateLookup.year": "ปี",
	"neptune.FlowNavigation.back": "กลับไปที่ขั้นก่อนหน้า",
	"neptune.Info.ariaLabel": "ข้อมูลเพิ่มเติม",
	"neptune.Label.optional": "(ไม่บังคับ)",
	"neptune.Link.opensInNewTab": "(เปิดในแท็บใหม่)",
	"neptune.MoneyInput.Select.placeholder": "เลือกตัวเลือก...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "เลือกสกุลเงิน",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "เลือกตัวเลือก...",
	"neptune.Select.searchPlaceholder": "ค้นหา...",
	"neptune.SelectInput.noResultsFound": "ไม่พบผลลัพธ์",
	"neptune.SelectOption.action.label": "เลือก",
	"neptune.SelectOption.selected.action.label": "เปลี่ยนตัวเลือกที่เลือกไว้",
	"neptune.StatusIcon.iconLabel.error": "ข้อผิดพลาด:",
	"neptune.StatusIcon.iconLabel.information": "ข้อมูล:",
	"neptune.StatusIcon.iconLabel.pending": "รอดำเนินการ:",
	"neptune.StatusIcon.iconLabel.success": "สำเร็จ:",
	"neptune.StatusIcon.iconLabel.warning": "คำเตือน:",
	"neptune.Summary.statusDone": "รายการที่ทำแล้ว",
	"neptune.Summary.statusNotDone": "รายการที่ต้องทำ",
	"neptune.Summary.statusPending": "รายการที่รอดำเนินการ",
	"neptune.Table.actionHeader": "การดำเนินการ",
	"neptune.Table.emptyData": "ไม่พบผลลัพธ์",
	"neptune.Table.loaded": "โหลดข้อมูลตารางแล้ว",
	"neptune.Table.loading": "กำลังโหลดข้อมูลตาราง",
	"neptune.Table.refreshPage": "รีเฟรชหน้า",
	"neptune.Upload.csButtonText": "อัปโหลดไฟล์อื่นหรือไม่",
	"neptune.Upload.csFailureText": "การอัปโหลดล้มเหลว กรุณาลองอีกครั้ง",
	"neptune.Upload.csSuccessText": "อัปโหลดเรียบร้อย!",
	"neptune.Upload.csTooLargeMessage": "กรุณาใช้ไฟล์ที่มีขนาดเล็กกว่า {maxSize} MB",
	"neptune.Upload.csWrongTypeMessage": "ไม่รองรับประเภทไฟล์ โปรดลองอีกครั้งโดยใช้ไฟล์อื่น",
	"neptune.Upload.psButtonText": "ยกเลิก",
	"neptune.Upload.psProcessingText": "กำลังอัปโหลด...",
	"neptune.Upload.retry": "ลองอีกครั้ง",
	"neptune.Upload.usButtonText": "หรือเลือกไฟล์",
	"neptune.Upload.usDropMessage": "วางไฟล์เพื่อเริ่มการอัปโหลด",
	"neptune.Upload.usPlaceholder": "ลากและวางไฟล์ที่น้อยกว่า {maxSize} MB",
	"neptune.UploadButton.allFileTypes": "ไฟล์ทุกประเภท",
	"neptune.UploadButton.dropFiles": "วางไฟล์เพื่อเริ่มการอัปโหลด",
	"neptune.UploadButton.instructions": "{fileTypes} น้อยกว่า {size} MB",
	"neptune.UploadButton.maximumFiles": "สูงสุด {maxFiles} ไฟล์",
	"neptune.UploadButton.uploadFile": "อัปโหลดไฟล์",
	"neptune.UploadButton.uploadFiles": "อัปโหลดไฟล์",
	"neptune.UploadInput.deleteModalBody": "การลบไฟล์นี้จะลบออกจากระบบของเรา",
	"neptune.UploadInput.deleteModalCancelButtonText": "ยกเลิก",
	"neptune.UploadInput.deleteModalConfirmButtonText": "ลบ",
	"neptune.UploadInput.deleteModalTitle": "แน่ใจหรือไม่ว่าต้องการลบไฟล์นี้",
	"neptune.UploadInput.fileIsTooLarge": "ไฟล์ใหญ่เกินไป",
	"neptune.UploadInput.fileTypeNotSupported": "ไม่รองรับประเภทไฟล์",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "ขออภัย การอัปโหลดนี้ไม่สำเร็จเนื่องจากเรายอมรับได้แค่ครั้งละ {maxFilesAllowed} ไฟล์",
	"neptune.UploadItem.deleting": "กำลังลบ...",
	"neptune.UploadItem.removeFile": "ลบไฟล์ {filename}",
	"neptune.UploadItem.uploaded": "อัปโหลดแล้ว",
	"neptune.UploadItem.uploadedFile": "ไฟล์ที่อัปโหลด",
	"neptune.UploadItem.uploading": "กำลังอัปโหลด...",
	"neptune.UploadItem.uploadingFailed": "อัปโหลดไม่สำเร็จ"
};

export { th as default };
//# sourceMappingURL=th.json.mjs.map
